module.exports = __webpack_public_path__ + "static/media/cnh-frente.826e2560.svg";